<template>
  <div>
    <!--    头部-->
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar">
    </NavTop>
    <!--    图片-->
    <div class="nav_bottom_img"  v-for="(slide, index) in time" :key="index" >
      <img :src="slide.url" alt="">
    </div>

    <!--  3个盒子  -->
    <div class="news_box_bgcolor">
      <div class="center">
        <div class="news_box row" >
          <div class="news_item" v-for="(item,index) in noticeData" :key="index">
            <div class="news_header row">
              <div class="title">{{ item.childName }}</div>
              <span v-if="item.appointTabId != null" @click="goTiaoZhuan(item.appointTabId)">
              查看更多
            </span>
              <span v-else @click="goTiaoZhuanSpan(item.parentId,item.id)">查看更多</span>
            </div>
            <div class="notice_con_list">
              <ul class="notice_con_list_ul">
                <li class="notice_con_list_ul_li" v-for="(item1,index1) in item.articleList" :key="index1">
                  <a class="notice_con_list_ul_li_a" href="">
                    <span class="notice_con_list_ul_li_a" v-if="title.appointTabId == null" @click="routerpush(title.parentId,item1.tabBarId,item1.id)">
                  {{item1.title}}</span>
                    <span v-else @click="routerpushSpan(title.appointTabId, item1.id)">{{ item1.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavTop from '../../components/comcomponents/NavTop.vue'
import child from '../../api/child'
import home from '../../api/home'

export default {
  components: {
    NavTop,
  },
  data () {
    return {
      noticeData: [],
      time:[],
      title:[]
    }
  },
  mounted () {
    this.getWenZhang(this.$route.params.tabBarId)
    this.getBannerList('/continue/education')

  },
  methods: {

    async getBannerList (bannerPath) {
      const res = await home.getBanner({
        bannerPath
      })
      console.log(res)
      this.time = res.rows
      console.log(this.time)
      if (res.code == 200) {
        // 轮播
        this.slides = res.data.filter(item => item.isBanner == 1)
        // 学校新闻列表
        this.dept_list = res.data.filter(item => item.isBanner == 0)
        console.log(this.dept_list)
      }
    },
    navigateTo (path) {
      this.$router.push(path)
    },
    async getWenZhang (tabBarId) {
      const res = await child.getChild({tabBarId: tabBarId})
      if (res.code == 200) {
        const data = res.data
        console.log(data)
        this.title = data
        // 通知公告数据
        this.noticeData = data.slice(0,3)
        console.log(this.noticeData)
      }
    },
    goGengD (parentId, id) {
      this.$router.push({
        path: '/common/section/more' + '/' + parentId + '/' + id
      })
    },
    // 点击上方查看更多
    goTiaoZhuan (appointTabId) {
      this.$router.push('/common/section/more' + '/' + appointTabId)
    },
    goTiaoZhuanSpan (parentId,id) {
      this.$router.push('/common/section/more'+ '/' + parentId + '/' + id)
    },
    routerpush (parentId, tabBarId, id) {
      this.$router.push('/common/section/detail' + '/' + parentId + '/' + tabBarId + '/' + id)
    },
    routerpushSpan (appointTabId, id) {
      this.$router.push('/common/section/detail' + appointTabId + '/' + id)
    },
  }
}
</script>
<style>
.center {
  margin: 0 auto;
  /*padding: 20px 0;*/
  width: 1245px;
}

.news_box_bgcolor {
  background-color: #f9f9f9;
}

.nav_bottom_img {
  width: 100%;
  height: 400px;
}
.nav_bottom_img img{
  width: 100%;
  height: 400px;
}

.row {
  display: flex;
  flex-direction: row;
}

.nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.news_item {
  color: #444444;
  width: calc((100% / 3) - 2%);
  margin: 2%;

  border: 1px solid #eeeeee;
  padding: 30px;
  background-color: #FFFFFF;
  .notice_con_list {
    height: 280px;
    overflow: hidden;
    .notice_con_list_ul {
      width: 100%;
      height: 100%;
      padding-top: 10px;

      .notice_con_list_ul_li {
        height: 45px;
        padding-left: 20px;
        position: relative;
        border-bottom: 1px solid #eee;
        line-height: 45px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        &::after {
          content: "";
          position: absolute;
          width: 5px;
          height: 5px;
          background: #8d080e;
          border-radius: 50%;
          left: 0;
          top: 50%;
        }

        .notice_con_list_ul_li_a {
          width: 100%;
          color: #333;
          display: block;
          text-decoration: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;

          &:hover {
            color: #7c2c2c;
          }
        }
      }
    }
  }
}

.news_header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  div{
    &:nth-child(2):hover{
      cursor: pointer;
      color: #8D080E;
    }
  }
}

.right {
  img {
    width: 20px;
    height: 20px;
  }
}

.title {
  font-size: 26px;
  border-bottom: 3px solid #8d080e;
  padding: 0 0 10px 0;
}

.news_ul {
  margin: 0 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.news_li::marker {
  color: #8d080e;
}

.news_li:hover {
  cursor: pointer;
  color: #8d080e;
}

</style>



// WEBPACK FOOTER //
// src/views/continue/education.vue